import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import notificate from "./modules/notificate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { user, notificate },
  state: {
    isFolded: true,
    isExpanded: false,
  },
  mutations: {
    SET_ISFOLDED: (state, data) => {
      state.isFolded = data;
    },
    SET_ISEXPANDED: (state, data) => {
      state.isExpanded = data;
    },
  },
  actions: {
    ISFOLDED_CHANGE({ commit }, data) {
      commit("SET_ISFOLDED", data);
    },
    ISEXPANDED_CHANGE({ commit }, data) {
      commit("SET_ISEXPANDED", data);
    },
  },
  getters: {
    ISFOLDED(state) {
      return state.isFolded;
    },
    ISEXPANDED(state) {
      return state.isExpanded;
    },
  },
});
